import { ApiAuthRepository } from '@core/authentication/repositories/api.auth.repository';
import { FakeAuthRepository } from '@core/authentication/repositories/fake.auth.repository';
import { ACCOUNTING_EVENT_REPOSITORY } from '@core/repositories/accounting-events.repository';
import { ACCOUNTING_GROUP_REPOSITORY } from '@core/repositories/accounting-groups.repository';
import { ACCOUNTING_REPOSITORY } from '@core/repositories/accounting.repository';
import { AML_LIMIT_REPOSITORY } from '@core/repositories/aml-limits.repository';
import { AUTH_REPOSITORY } from '@core/repositories/auth.repository';
import { CHANNEL_REPOSITORY } from '@core/repositories/channels.repository';
import { COMMISSION_REPOSITORY } from '@core/repositories/commissions.repository';
import { CONSTANTS_REPOSITORY } from '@core/repositories/constants.repository';
import { CUSTOMER_REPOSITORY } from '@core/repositories/customers.repository';
import { PAYMENT_METHODS_REPOSITORY } from '@core/repositories/payment-methods.repository';
import { ROLES_REPOSITORY } from '@core/repositories/roles.repository';
import { RULES_REPOSITORY } from '@core/repositories/rules.repository';
import { SEGMENT_REPOSITORY } from '@core/repositories/segments.repository';
import { STATE_REPOSITORY } from '@core/repositories/status.repository';
import { TEMPLATES_REPOSITORY } from '@core/repositories/templates.repository';
import { TRANSACIONAL_EVENTS_REPOSITORY } from '@core/repositories/transactional-events.repository';
import { TRANSFER_REPOSITORY } from '@core/repositories/transfers.repository';
import { USERS_REPOSITORY } from '@core/repositories/users.repository';
import { ApiAccountingEventsRepository } from '@modules/accounting-events/repositories/api.accounting-events.repository';
import { FakeAccountingEventsRepository } from '@modules/accounting-events/repositories/fake.accounting-events.repository';
import { ApiAccountingGroupsRepository } from '@modules/accounting-groups/repositories/api.accounting-groups.repository';
import { FakeAccountingGroupsRepository } from '@modules/accounting-groups/repositories/fake.accounting-groups.repository';
import { ApiAccountingRepository } from '@modules/accounting/repositories/api.accounting.repository';
import { FakeAccountingRepository } from '@modules/accounting/repositories/fake.accounting.repository';
import { ApiAmlLimitsRepository } from '@modules/aml-limits/repositories/api.aml-limits.repository';
import { FakeAmlLimitsRepository } from '@modules/aml-limits/repositories/fake.aml-limits.repository';
import { ApiChannelsRepository } from '@modules/channels/repositories/api.channels.repository';
import { FakeChannelsRepository } from '@modules/channels/repositories/fake.channels.repository';
import { ApiCommissionsRepository } from '@modules/commissions/repositories/api.commissions.repository';
import { FakeCommissionsRepository } from '@modules/commissions/repositories/fake.commissions.repository';
import { ApiConstantsRepository } from '@modules/constants/repositories/api.constants.repository';
import { FakeConstantsRepository } from '@modules/constants/repositories/fake.constants.repository';
import { ApiCustomersRepository } from '@modules/customers/repositories/api.customers.repository';
import { FakeCustomersRepository } from '@modules/customers/repositories/fake.customers.repository';
import { ApiPaymentMethodsRepository } from '@modules/payment-methods/repositories/api.payment-methods.repository';
import { FakePaymentMethodsRepository } from '@modules/payment-methods/repositories/fake.payment-methods.repository';
import { ApiRolesRepository } from '@modules/roles/repositories/api.roles.repository';
import { FakeRolesRepository } from '@modules/roles/repositories/fake.roles.repository';
import { ApiRulesRepository } from '@modules/rules/repositories/api.rules.repository';
import { FakeRulesRepository } from '@modules/rules/repositories/fake.rules.repository';
import { ApiSegmentsRepository } from '@modules/segments/repositories/api.segments.repository';
import { FakeSegmentsRepository } from '@modules/segments/repositories/fake.segments.repository';
import { ApiStatusRepository } from '@modules/status/repositories/api.status.repository';
import { FakeStatusRepository } from '@modules/status/repositories/fake.status.repository';
import { ApiTemplatesRepository } from '@modules/templates/repositories/api.templates.repository';
import { FakeTemplatesRepository } from '@modules/templates/repositories/fake.templates.repository';
import {
  ApiTransactionalEventsRepository,
} from '@modules/transactional-events/repositories/api.transactional-events.repository';
import {
  FakeTransactionalEventsRepository,
} from '@modules/transactional-events/repositories/fake.transactional-events.repository';
import { ApiTransfersRepository } from '@modules/transfers/repositories/api.transfers.repository';
import { FakeTransfersRepository } from '@modules/transfers/repositories/fake.transfers.repository';
import { ApiUsersRepository } from '@modules/users/repositories/api.users.repository';
import { FakeUsersRepository } from '@modules/users/repositories/fake.users.repository';

export const SERVICE_PROVIDERS = {
  [ACCOUNTING_EVENT_REPOSITORY]: {
    default: ApiAccountingEventsRepository,
    local: FakeAccountingEventsRepository
  },
  [ACCOUNTING_GROUP_REPOSITORY]: {
    default: ApiAccountingGroupsRepository,
    local: FakeAccountingGroupsRepository
  },
  [ACCOUNTING_REPOSITORY]: {
    default: ApiAccountingRepository,
    local: FakeAccountingRepository
  },
  [AML_LIMIT_REPOSITORY]: {
    default: ApiAmlLimitsRepository,
    local: FakeAmlLimitsRepository
  },
  [AUTH_REPOSITORY]: {
    default: ApiAuthRepository,
    local: FakeAuthRepository
  },
  [CHANNEL_REPOSITORY]: {
    default: ApiChannelsRepository,
    local: FakeChannelsRepository
  },
  [COMMISSION_REPOSITORY]: {
    default: ApiCommissionsRepository,
    local: FakeCommissionsRepository
  },
  [CONSTANTS_REPOSITORY]: {
    default: ApiConstantsRepository,
    local: FakeConstantsRepository
  },
  [CUSTOMER_REPOSITORY]: {
    default: ApiCustomersRepository,
    local: FakeCustomersRepository
  },
  [PAYMENT_METHODS_REPOSITORY]: {
    default: ApiPaymentMethodsRepository,
    local: FakePaymentMethodsRepository
  },
  [ROLES_REPOSITORY]: {
    default: ApiRolesRepository,
    local: FakeRolesRepository
  },
  [RULES_REPOSITORY]: {
    default: ApiRulesRepository,
    local: FakeRulesRepository
  },
  [SEGMENT_REPOSITORY]: {
    default: ApiSegmentsRepository,
    local: FakeSegmentsRepository
  },
  [STATE_REPOSITORY]: {
    default: ApiStatusRepository,
    local: FakeStatusRepository
  },
  [TEMPLATES_REPOSITORY]: {
    default: ApiTemplatesRepository,
    local: FakeTemplatesRepository
  },
  [TRANSACIONAL_EVENTS_REPOSITORY]: {
    default: ApiTransactionalEventsRepository,
    local: FakeTransactionalEventsRepository
  },
  [TRANSFER_REPOSITORY]: {
    default: ApiTransfersRepository,
    local: FakeTransfersRepository
  },
  [USERS_REPOSITORY]: {
    default: ApiUsersRepository,
    local: FakeUsersRepository
  }
};
